import { Role } from '~/common/providers/auth/role';
import { useMyRole } from '~/common/providers/auth/use-login-user';

export const useRoleGuard = (allowedRoles: Role[]) => {
  const myRole = useMyRole();
  const permitted = !!myRole && allowedRoles.includes(myRole);
  return permitted;
};
